   /* Get the audio from the player (using the player's ID), the [0] is necessary */
   var mouseovertimer;
   /* Global variable for a timer. When the mouse is hovered over the speaker it will start playing after hovering for 1 second, if less than 1 second it won't play (incase you accidentally hover over the speaker) */
   var audiostatus = 'off';
   /* Global variable for the audio's status (off or on). It's a bit crude but it works for determining the status. */

   $(document).on('mouseenter', '.speaker', function() {
        var id = $(this).parent().find("input[name=sku]").val();
        var audio = $(this).parent().find("audio")[0];

         /* Bonus feature, if the mouse hovers over the speaker image for more than 1 second the audio will start playing */
         if (!mouseovertimer) {
           mouseovertimer = window.setTimeout(function() {
             mouseovertimer = null;
             $(".speaker").each(function(){
                 if($(this).attr("id") == id){
                     if (!$(this).hasClass("speakerplay")) {
                       audio.load();
                       /* Loads the audio */
                       audio.play();
                       /* Play the audio (starting at the beginning of the track) */
                       $(this).addClass('speakerplay');
                       return false;
                     }else if($(this).hasClass("speakerplay")){
                         audio.pause();
                         $(this).removeClass('speakerplay');  
                         window.clearTimeout(mouseovertimer);
             			 audiostatus = 'on';
                     }
                 }
             });
           }, 1000);
         }
   });

   $(document).on('mouseleave', '.speaker', function() {
     /* If the mouse stops hovering on the image (leaves the image) clear the timer, reset back to 0 */
     if (mouseovertimer) {
       window.clearTimeout(mouseovertimer);
       mouseovertimer = null;
     }
   });

   $(document).on('click touchend', '.speaker', function() {
     
     var id = $(this).parent().find("input[name=sku]").val();
     var audio = $(this).parent().find("audio")[0];
     
     /* Touchend is necessary for mobile devices, click alone won't work */
     $(".speaker").each(function(){
         if($(this).attr("id") == id){
           if (!$(this).hasClass("speakerplay")) {
             if (audiostatus == 'off') {
               $(this).addClass('speakerplay');
               audio.load();
               audio.play();
               window.clearTimeout(mouseovertimer);
               audiostatus = 'on';
               return false;
             } else if (audiostatus == 'on') {
               $(this).addClass('speakerplay');
               audio.play();
             }
           }else if ($(this).hasClass("speakerplay")) {
             audio.pause();
             $(this).removeClass('speakerplay');
             window.clearTimeout(mouseovertimer);
             audiostatus = 'on';
     	   }
         }
   		});
   });

   $('#player').on('ended', function() {
     var id = $(this).parent().find("input[name=sku]").val();
     var audio = $(this).parent().find("audio")[0];
     
	 $(".speaker").each(function(){
         if($(this).attr("id") == id){ 
            $(this).removeClass('speakerplay');
         }
     });
    
     /*When the audio has finished playing, remove the class speakerplay*/
     audiostatus = 'off';
     /*Set the status back to off*/
   });